import { useRecordContext} from 'react-admin';
import React from "react";

const IsBlackListField = props => {
    const record = useRecordContext();

    return <span>{record ? `${props.list.find(el => el.id === record.isBlackList).name}` : ''}</span>;
};

export default IsBlackListField;

